import { isObject } from '@bxp-framework/utils';
export function isImageType(value) {
    return ['image', 'gradient'].includes(value);
}
export function isAngle(value) {
    return [0, 60, 90, 120, 180, 240, 270, 300].includes(value);
}
export function isImage(value) {
    if (!isObject(value)) {
        return false;
    }
    const temp = value;
    return (isImageType(temp.type) &&
        isObject(temp.image) &&
        typeof temp.image.id === 'string' &&
        typeof temp.image.value === 'string' &&
        isObject(temp.gradient) &&
        typeof temp.gradient.value === 'string' &&
        isAngle(temp.gradient.angle));
}
//# sourceMappingURL=image.js.map